import { render, staticRenderFns } from "./modalErrorPass.vue?vue&type=template&id=121d742e&"
import script from "./modalErrorPass.vue?vue&type=script&lang=js&"
export * from "./modalErrorPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports